export const Colors = {
  black: '#0f0f0f',
  white: '#ffffff',
  brandPrimary: '#a23aff',
  brandPrimaryInvert: '#b566f9',
  brandSecondary: '#09a99c',
  info: '#5cbbff',
  success: '#40b95c',
  warning: '#ffc107',
  danger: '#ef4d61',
  indigo100: '#0f0f1b',
  indigo200: '#cdcdff',
  indigo300: '#ababff',
  indigo400: '#8888ff',
  indigo500: '#6262f5',
  indigo600: '#4c4cd3',
  indigo700: '#3838b1',
  indigo800: '#27278f',
  indigo900: '#1a1a6d',
  purple100: '#f2eeff',
  purple200: '#d5caff',
  purple300: '#b7a5ff',
  purple400: '#9a81ff',
  purple500: '#7a5af8',
  purple600: '#6144d6',
  purple700: '#4c32b4',
  purple800: '#382292',
  purple900: '#271570',
  blue100: '#e5f4ff',
  blue200: '#b7e1ff',
  blue300: '#8aceff',
  blue400: '#5cbbff',
  blue500: '#0095ff',
  blue600: '#0095ff',
  blue700: '#007dd6',
  blue800: '#006ded',
  blue900: '#004e85',
  green100: '#e9fcf1',
  green200: '#b7f7d2',
  green300: '#8af5b4',
  green400: '#32ee7d',
  green500: '#1ecc64',
  green600: '#0eaa4d',
  green700: '#0eaa4d',
  green800: '#038838',
  green900: '#006629',
  red100: '#ffeeee',
  red200: '#ffc8c8',
  red300: '#ffa2a2',
  red400: '#ff7c7c',
  red500: '#f85454',
  red600: '#d63f3f',
  red700: '#b42d2d',
  red800: '#921e1e',
  red900: '#701212',
  yellow100: '#fff9e7',
  yellow200: '#fff0bd',
  yellow300: '#ffe693',
  yellow400: '#ffdc69',
  yellow500: '#ffd23f',
  yellow600: '#fac515',
  yellow700: '#d1a102',
  yellow800: '#a88100',
  yellow900: '#806200',
  pink100: '#ffedf9',
  pink200: '#ffc4ed',
  pink300: '#ff9ce1',
  pink400: '#fd73d3',
  pink500: '#ee46bc',
  pink600: '#cc329e',
  pink700: '#aa2281',
  pink800: '#881465',
  pink900: '#660a4a',
  orange100: '#fff1e5',
  orange200: '#fcdcbd',
  orange300: '#ffc28a',
  orange400: '#ffaa5c',
  orange500: '#ff922e',
  orange600: '#ff7a00',
  orange700: '#d66700',
  orange800: '#ad5300',
  orange900: '#854000',
  gray100: '#f8f8f8',
  gray200: '#f1f0f0',
  gray300: '#dedede',
  gray400: '#a9aeac',
  gray500: '#888d8c',
  gray600: '#5f6161',
  gray700: '#404040',
  gray800: '#323232',
  gray900: '#181818',
} as const

export type Theme = 'light' | 'dark'

export type ThemeColorName =
  | 'surfacePrimary'
  | 'surfaceSecondary'
  | 'surfaceSecondaryPressed'
  | 'surfaceTertiary'
  | 'surfaceBrand'
  | 'surfacePrimaryInvert'
  | 'surfaceSecondaryInvert'
  | 'surfaceTertiaryInvert'
  | 'textPrimary'
  | 'textPrimaryInvert'
  | 'textSecondary'
  | 'textSecondaryInvert'
  | 'textDisabled'
  | 'borderColor'
  | 'borderColorSelected'
  | 'borderColorHover'
  | 'borderColorActive'
  | 'borderColorFocus'
  | 'borderColorError'

export const ThemeColors = {
  light: {
    surfacePrimary: Colors.gray100,
    surfaceSecondary: Colors.white,
    surfaceSecondaryPressed: Colors.gray100,
    surfaceTertiary: Colors.gray100,
    surfaceBrand: Colors.brandPrimary,
    surfacePrimaryInvert: Colors.black,
    surfaceSecondaryInvert: Colors.gray900,
    surfaceTertiaryInvert: Colors.gray800,
    textPrimary: Colors.black,
    textPrimaryInvert: Colors.white,
    textSecondary: Colors.gray600,
    textSecondaryInvert: Colors.gray400,
    textDisabled: Colors.gray400,
    borderColor: Colors.gray300,
    borderColorSelected: Colors.brandPrimaryInvert,
    borderColorHover: Colors.gray400,
    borderColorActive: Colors.gray500,
    borderColorFocus: Colors.brandPrimary,
    borderColorError: Colors.danger,
  },
  dark: {
    surfacePrimary: Colors.black,
    surfaceSecondary: Colors.black,
    surfaceSecondaryPressed: Colors.gray900,
    surfaceTertiary: Colors.gray900,
    surfaceBrand: Colors.brandPrimaryInvert,
    surfacePrimaryInvert: Colors.white,
    surfaceSecondaryInvert: Colors.gray100,
    surfaceTertiaryInvert: Colors.gray200,
    textPrimary: Colors.white,
    textPrimaryInvert: Colors.black,
    textSecondary: Colors.gray400,
    textSecondaryInvert: Colors.gray600,
    textDisabled: Colors.gray600,
    borderColor: Colors.gray800,
    borderColorSelected: Colors.brandPrimary,
    borderColorHover: Colors.gray700,
    borderColorActive: Colors.gray600,
    borderColorFocus: Colors.brandPrimary,
    borderColorError: Colors.danger,
  },
} as const

export function getColor(colorName: ThemeColorName, theme: Theme): string {
  return ThemeColors[theme][colorName]
}
